import { render } from "./Sidemenu.vue?vue&type=template&id=66aeef48"
import script from "./Sidemenu.vue?vue&type=script&lang=js"
export * from "./Sidemenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__